import { Button, message, Row, Col } from 'antd';
import React, { useState } from 'react';
import QRReader from 'react-qr-reader';

const FRONT_CAMERA = 'user';
const MAIN_CAMERA = 'environment';

const CameraScanner = ({ onScan }) => {
  const [cameraFacing, setCameraFacing] = useState(MAIN_CAMERA);

  const handleCameraOption = () => {
    if (cameraFacing === MAIN_CAMERA) {
      setCameraFacing(FRONT_CAMERA);
    } else {
      setCameraFacing(MAIN_CAMERA);
    }
  }

  const handleError = (err) => {
    message.error("QR Code scan failed");
  }

  const handleScan = (data) => {
    if (data) {
      onScan(data);
    }
  }

  const isFrontCam = () => {
    return cameraFacing === FRONT_CAMERA;
  }

  const ScanningMode = () => {
    return (
      <div style={{ minHeight: 300, margin: "25px auto 0px auto", borderRadius: "5px", border: "1px solid #ebebeb" }}>
        <div className="gx-mb-3 gx-mt-3">
          <h4>Arahkan Kamera ke QR Code</h4>
        </div>
        <QRReader facingMode={cameraFacing} delay={300} onScan={handleScan} onError={handleError} style={{ width: '100%' }} />
        <Button type="primary" onClick={handleCameraOption} className="gx-mt-3">
          {isFrontCam() ? 'Gunakan Kamera Belakang' : 'Gunakan Kamera Depan'}
        </Button>
      </div>
    );
  }

  return <ScanningMode />;
}

export default CameraScanner;